module.exports = __webpack_public_path__ + "static/media/29ADMSPC25.8b7a5c36.jpg";